var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"config-text-options",class:_vm.configClasses},[_c('div',{staticClass:"text"},[_vm._t("input")],2),_c('div',{staticClass:"slot"},[_vm._t("buttons")],2)]),(_vm.isInputValid)?_c('div',{staticClass:"warning"},[_vm._t("msg")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }